import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import DiscountIcon from "@mui/icons-material/Discount";
import { useCompany } from "../../components/context/CompanyContext";
import CustomGrid from "../../components/grid/CustomGrid";
import Loading from "../../components/loading/loading";
import { titleSetRef } from "../../redux/titleRedux";
import { userRequest, generateFileUrl } from "../../requestMethods";
import { withVisibleDays } from "../../util/visibleDays";
import "../../App.css";

const BASE_COLUMNS = [
  {
    field: "avatar",
    headerName: "Foto",
    align: "center",
    headerAlign: "center",
    width: 50,
    renderCell: (params) => (
      <Avatar sx={{ width: "30px", height: "30px" }} src={generateFileUrl(params.value)} />
    ),
  },
  {
    field: "status",
    headerName: "Status Produto",
    width: 120,
    align: "center",
    headerAlign: "center",
    type: "text",
    description: "S = todas numeração tem em estoque, P = alguma numeração não tem em estoque, N = não tem estoque",
    renderCell: (params) => {
      switch (params.value) {
        case "S":
          return <CheckCircleOutlineOutlinedIcon color="success" />;
        case "N":
          return <RemoveCircleOutlineOutlinedIcon sx={{ color: "red" }} />;
        case "P":
          return <ReportGmailerrorredIcon sx={{ color: "#EE8253" }} />;
        default:
          return null;
      }
    },
  },
  { field: "product", headerName: "Referência", width: 150, align: "center", headerAlign: "center", type: "text" },
  {
    field: "promo",
    headerName: "Promocional",
    width: 130,
    align: "center",
    headerAlign: "center",
    type: "boolean",
    renderCell: (params) => (params.value ? <DiscountIcon color="success" /> : false),
  },
  {
    field: "color",
    headerName: "Cor",
    width: 80,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <Box sx={{ height: "30px", width: "30px", backgroundColor: params.value, borderRadius: "5px" }} />
    ),
  },
  { field: "category", headerName: "Categoria", width: 180, align: "center", headerAlign: "center", type: "text" },
  { field: "subCategory", headerName: "Sub Categoria", width: 180, align: "center", headerAlign: "center", type: "text" },
  { field: "visibleAt", headerName: "Visível", width: 100, align: "center", headerAlign: "center", type: "date", format: "dd/MM/yyyy" },
  // Calculado no load (withVisibleDays): CustomGrid não repassa valueGetter.
  { field: "visibleDays", headerName: "Dias Visíveis", width: 110, align: "center", headerAlign: "center", type: "number" },
  { field: "total", headerName: "Total", format: "BRL", width: 90, align: "center", headerAlign: "center", type: "number" },
];

// Tela dedicada "Estoque" — só a tabela de estoque completo, layout novo.
export default function RelatorioEstoque() {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const { companyId, slug } = useCompany();

  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState(BASE_COLUMNS);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(titleSetRef({ title: "Relatório de Estoque" }));
    window.scrollTo(0, 0);
  }, [dispatch]);

  useEffect(() => {
    if (companyId > 0) carregar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  const carregar = async () => {
    setIsLoading(true);
    try {
      // Colunas de tamanho (dinâmicas)
      try {
        const resSizes = await userRequest.get(`${companyId}/products/sizes`);
        const sizeCols = (resSizes.data || []).map((item) => ({
          field: item.ref,
          headerName: item.label,
          width: 80,
          align: "center",
          headerAlign: "center",
        }));
        setColumns([...BASE_COLUMNS, ...sizeCols]);
      } catch {}

      const res = await userRequest.get(`${companyId}/grid/stock`);
      setRows(withVisibleDays(res.data));
    } catch {
      setRows([]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ padding: "16px 16px 48px 4px", fontFamily: "Manrope", background: "#F9FAFB", minHeight: "100vh" }}>
      <div
        onClick={() => nav(`/${slug}/indicadoresprodutos`)}
        style={{
          display: "inline-flex", alignItems: "center", gap: 6, marginBottom: 12, cursor: "pointer",
          color: "#6B7280", fontSize: 13, fontWeight: 600, fontFamily: "Manrope",
          padding: "6px 12px", borderRadius: 8, border: "1px solid #E5E7EB",
          background: "#fff", boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
        }}
      >
        ← Voltar para Indicadores
      </div>

      <div style={{ marginBottom: 20 }}>
        <span style={{ fontSize: 18, fontWeight: 700, color: "#111827" }}>Estoque</span>
        <span style={{ fontSize: 12, color: "#9CA3AF", marginLeft: 8 }}>estoque completo</span>
      </div>

      {isLoading ? (
        <Loading />
      ) : (
        <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #E5E7EB", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", padding: "16px" }}>
          <div style={{ height: "calc(100vh - 200px)", width: "100%" }}>
            <CustomGrid
              gridId="relatorioEstoque"
              rows={rows}
              columns={columns}
              pageSize={45}
              checkboxSelection={false}
            />
          </div>
        </div>
      )}
    </div>
  );
}
